/**
 * 악덕알리미 체불 리스트 — JS 렌더 + 20건씩 이어 붙이는 무한스크롤(더보기 버튼 폴백).
 * 데이터/마스킹은 서버(/b/ajax/master, offset 방식·20건 고정)에서 받아 표시만 한다.
 * 카드 렌더·상세 BS 는 공용 $j.F.Devil.Render 사용.
 *
 * 2026-10-21 대표님 요청 — 페이지 번호(‹ 1 2 … 67 ›) 대신, 끝까지 내리면 다음 20건이 자동으로 아래에 붙는다.
 *   감시 대상은 목록 끝 '더보기' 칸(#b-list-more, $j.Ui.InfiniteScroll 규약) — 더 받을 게 없으면 hidden 이라 자동 로드도 멈춘다.
 *   IntersectionObserver 가 없는 기기·요청 실패 뒤에는 '더보기' 버튼이 남아 손으로 더 받는다.
 */
const PAGE_SIZE = 20;

export default class List {
    constructor() {
        this.keyword = '';
        this.sort    = 'all';
        this.total   = 0;
        this.loaded  = 0;         // 지금까지 받은 건수 = 다음 요청의 offset
        this.done    = false;     // 더 받을 게 없음
        this.loading = false;
        this.seq     = 0;         // 조건(검색·정렬)이 바뀐 뒤 늦게 온 응답을 버리는 번호 (Pages/Mobile/Cash.js 와 같은 방식)
        this.seen    = new Set(); // 이미 그린 master_num — offset 방식이라 사이에 새 업체가 끼면 한 건이 겹칠 수 있어 걸러낸다
        this.scroll  = null;      // $j.Ui.InfiniteScroll 제어 {pause,resume,destroy}. null 이면 버튼 폴백
    }

    initialize() {
        this.$list   = $('#b-list');
        this.$status = $('#b-list-status');
        this.$total  = $('#b-list-total');
        this.$more   = $('#b-list-more');
        this.$scroll = this.$list.closest('.b-scroll');

        this.bindSearch();
        this.bindSort();
        this.bindMore();

        // 카드 클릭 → 상세 BS (페이지 이동 없이 BottomSheet 로 표시)
        this.$list.on('click', '.b-lc', (e) => {
            const num = $(e.currentTarget).data('master');
            if (!num) return;
            $j.Ui.BS.open({ target: $j.F.Devil.Render.masterTarget(num), fixedHeight: true, backClose: true });
        });

        this.reload();
    }

    bindSearch() {
        const $q = $('#b-list-q');
        const $reset = $('#b-list-reset');
        const $go = $('#b-list-go');

        // 입력값 유무에 따라 리셋 버튼 노출
        const syncReset = () => $reset.prop('hidden', !$q.val().length);
        const search = () => { this.keyword = $q.val().trim(); this.reload(); };

        $q.on('input', syncReset);
        // Enter 로 조회하면 칸의 포커스를 빼 소프트 키보드를 내린다 — 키보드가 남아 결과 목록을 가렸다(2026-10-07 상필 님 QA).
        //   웹뷰·브라우저 모두 포커스가 빠지면 키보드가 내려가므로 앱(네이티브) 수정은 필요 없다. 홈 검색(Home.js)도 같게.
        $q.on('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); $q.trigger('blur'); search(); } });
        $go.on('click', search);

        // 리셋: 검색어 비우고 전체 목록으로. 즉시 반영.
        $reset.on('click', () => {
            $q.val('').focus();
            syncReset();
            if (this.keyword !== '') { this.keyword = ''; this.reload(); }
        });
    }

    bindSort() {
        $('.b-list__sorts .b-pill').on('click', (e) => {
            const $btn = $(e.currentTarget);
            this.sort = $btn.data('sort');
            $('.b-list__sorts .b-pill').removeClass('is-on');
            $btn.addClass('is-on');
            this.reload();
        });
    }

    // 목록 끝 '더보기' 칸 — 버튼(폴백) + 스크롤 자동 로드
    bindMore() {
        $('#b-list-more-btn').on('click', () => this.loadMore());
        this.scroll = $j.Ui.InfiniteScroll.attach(this.$more[0], {
            onLoad: () => this.loadMore(),
            root: this.$scroll[0] || null,   // 카드는 .b-scroll 안에서 스크롤되므로 그 상자를 기준으로 미리(320px) 당겨온다
            rootMargin: '320px 0px',
        });
        if (this.scroll) this.$more.addClass('is-auto');   // 버튼 감추고 '불러오는 중…' (scss). null 이면 버튼이 그대로 폴백
    }

    // 검색/정렬 변경 → 처음부터. 받는 중이어도 새 조건이 이긴다(seq 가 늦은 응답을 버린다)
    reload() {
        this.seq++;
        this.loaded = 0; this.done = false; this.loading = false; this.seen.clear();
        this.$list.empty();
        this.$more.prop('hidden', true);
        if (this.$scroll.length) this.$scroll.scrollTop(0);
        this.fetch();
    }

    loadMore() {
        if (this.loading || this.done) return;
        this.fetch();
    }

    fetch() {
        const seq = this.seq;
        this.loading = true;
        this.$status.text(this.loaded ? '' : '불러오는 중…');   // 이어 받을 땐 '더보기' 칸의 is-auto 표시가 대신한다
        if (this.scroll) this.$more.addClass('is-auto');          // 실패 뒤 버튼으로 바꿨던 것을 원복

        $.getJSON('/b/ajax/master', { keyword: this.keyword, sort: this.sort, offset: this.loaded })
            .done((res) => {
                if (seq !== this.seq) return;
                if (!res || !res.result) { this.onFail(); return; }

                this.total = Number(res.total) || 0;
                this.$total.text(this.total.toLocaleString());

                const rows  = res.data || [];
                const fresh = rows.filter((c) => !this.seen.has(c.master_num));
                fresh.forEach((c) => this.seen.add(c.master_num));
                this.$list.append(fresh.map((c) => this.cardHtml(c)).join(''));

                this.loaded += rows.length;
                this.done = rows.length === 0 || this.loaded >= this.total;   // 0건이면 total 이 어긋나도 멈춘다(같은 요청 반복 방지)
                this.$more.prop('hidden', this.done);
                this.$status.text(this.total === 0 ? '검색 결과가 없습니다.' : (this.done && this.total > PAGE_SIZE ? '목록의 끝입니다' : ''));   // 한 묶음에 다 들어오면 '끝' 문구 생략

                // 감시를 다시 건다 — 붙인 뒤에도 '더보기' 칸이 그대로 화면 안이면 교차 변화가 없어 다음 쪽이 안 불린다
                if (!this.done && this.scroll) { this.scroll.pause(); this.scroll.resume(); }
            })
            .fail(() => { if (seq === this.seq) this.onFail(); })
            .always(() => { if (seq === this.seq) this.loading = false; });   // 실패해도 반드시 푼다 — 다음 시도가 막히지 않게
    }

    // 실패 — 문구를 띄우고 '더보기' 칸을 버튼으로 바꿔 손으로 다시 시도하게 한다.
    // 자동 감시는 멈춘다(켜 두면 보이는 버튼이 교차 판정을 일으켜 실패를 되풀이한다). 다음 성공 때 다시 건다.
    onFail() {
        this.$status.text('불러오기 실패');
        if (this.scroll) this.scroll.pause();
        this.$more.removeClass('is-auto').prop('hidden', false);
    }

    cardHtml(c) {
        const R = $j.F.Devil.Render;
        const accent = R.typeAccent(c.type);
        const badgeMod = R.typeBadge(c.type);
        const amt = R.won(c.amount);
        // 2026-10-12 기획(유과장 리스트) — 카드 3줄: ① 뱃지+번호 ② 업체명+금액 ③ 체불자명·지역·건수. 사업자번호는 뺀다.
        //   체불자명 = 업자(개인) 제보면 업자명, 업체만이면 대표자명. 둘 다 서버가 가운데를 가린다(김*운, 내 제보건은 원본).
        //   지역은 서버가 구/군까지만 자른 값(region). '둘 다'·'업자' 제보는 상태 뱃지 옆에 작은 뱃지로 알린다.
        //   (2026-09-01 QA 로 고친 "라벨만 덩그러니" 버그는 그대로 — 값 있을 때만 라벨을 붙인다)
        const who = c.person_name ? '체불자 ' + c.person_name : (c.ceo_name ? '대표자 ' + c.ceo_name : '');
        const tgtTag = c.target_type === 'both' ? '<span class="b-badge b-badge--eq">업체·업자</span>'
                     : (c.target_type === 'pn' ? '<span class="b-badge b-badge--eq">업자</span>' : '');
        const foot = [who, c.region].filter(Boolean).join(' · ');

        return `
        <div class="b-card is-press ${accent} b-lc" data-master="${c.master_num}">
            <div class="b-lc__top">
                <div class="b-lc__badges">
                    <span class="b-badge ${badgeMod}">${R.esc(c.type)}</span>${tgtTag}
                </div>
                <span class="b-lc__phone">${R.esc(c.phone)}</span>
            </div>
            <div class="b-lc__main">
                <span class="b-lc__co">${R.esc(c.co_name || '미입력')}</span>
                <span class="b-lc__amt">${amt}</span>
            </div>
            <div class="b-lc__foot">
                <span class="b-lc__who">${R.esc(foot)}</span>
                <span class="b-lc__cnt">제보 ${c.report_cnt} · 통화 ${c.call_cnt}</span>
            </div>
        </div>`;
    }
}
